export enum CaptchaActions {
    CREATE = "create",
    SEND = "send",
    CHECK = "check"
}